import React from 'react';
import './style.scss';

export interface UQRowProps {
  children: React.ReactNode;
}

const UQRow: React.FC<UQRowProps> = ({ children }) => {
  return <div className="row">{children}</div>;
};

export default UQRow;